import getDeviceInfoSync from '../getDeviceInfoSync';
export function getEvnString(type) {
    return ['test', 'preonline', 'production', 'staging'][type];
}
export const envMap = {
    production: {
        type: 2,
        url: (() => {
            const hostname = window?.location?.hostname;
            if (getDeviceInfoSync().isOverseas) {
                return 'https://g-api.kittyfunny.com';
            }
            if (hostname?.indexOf('kuai-ying.com') > -1) {
                return 'https://api.kuai-ying.com';
            }
            return 'https://ky-api.kwaiying.com';
        })(),
    },
    preonline: {
        type: 1,
        url: 'https://preonline-kmovie-api.test.gifshow.com',
    },
    staging: {
        type: 3,
        url: 'https://kmovie-api.staging.kuaishou.com',
    },
    test: {
        type: 0,
        url: 'https://rd-kmovie-api.test.gifshow.com',
    },
};
